module.exports = __webpack_public_path__ + "img/LinkemSenzaLimiti-350x174.a1558d62.jpg";